export const ID_COMMCENTRE = 2; // Url = NULL
export const ID_MNI_MESSAGE = 3; // Url = /#/commcentre/inbox
export const ID_PARTICIPANTS = 4; // Url = /commcentre/whosonline.aspx
export const ID_MNU_PERSONAL = 5; // Url = NULL
export const ID_MNU_PRESENTATION = 6; // Url = /personal/editpresentation.aspx
export const ID_FILES = 7; // Url = /personal/files.aspx
export const ID_CALENDAR = 8; // Url = /calendar/calendar.aspx
export const ID_BULLETINBOARD = 9; // Url = NULL
export const ID_PORTAL = 10; // Url = /news/news.aspx
export const ID_COURSES = 11; // Url = /news/coursenews.aspx
export const ID_SETTINGS = 12; // Url = /personal/settings.aspx
export const ID_HISTORY = 13; // Url = /personal/history.aspx
export const ID_BLOG = 15; // Url = /blog/blogitems.aspx
export const ID_BLOGS = 16; // Url = /blog/searchblogs.aspx
export const ID_COLLEAGUES = 22; // Url = NULL
export const ID_LISTACTIVITIES = 27; // Url = NULL
export const ID_ATTESTATIONS = 29; // Url = /Activities/Attest.aspx
export const ID_SCHEDULEASSIGNMENTS = 30; // Url = /personal/scheduleassignments.aspx
export const ID_ASSIGNMENTSANDGRADES = 31; // Url = /personal/ungradedassignments.aspx
export const ID_EDUCATORTOOLS = 32; // Url = NULL
export const ID_MNUREPORTS = 33; // Url = /educatortools/reports.aspx
export const ID_ADMINTOOLS = 34; // Url = /activities/ForAdministrators.aspx
export const ID_ACTIVITIES_EDUCATORTOOLS = 35; // Url = /activities/foreducators.aspx
export const ID_COURSECONFIRMATIONS = 36; // Url = /personal/courseconfirmations.aspx
export const ID_MYATTESTATIONS = 38; // Url = /Activities/Attest.aspx
export const ID_FORCOORDINATORS = 39; // Url = /activities/forcoordinators.aspx
export const ID_LISTORDERS = 40; // Url = /activities/manageOrders.aspx
export const ID_SEARCHFORPEOPLE = 41; // Url = /activities/searchpeople.aspx
export const ID_MYROLEMANAGER = 43; // Url = NULL
export const ID_COWORKER_OVERVIEW = 44; // Url = /#/tm/coworker/dashboard
export const ID_COWORKER_COMPTALK = 45; // Url = /#/tm/coworker/comptalk
export const ID_COWORKER_GOALSANDACTIVITIES = 46; // Url = /#/tm/coworker/personalgoals/goal (...personalgoals/goals)
export const ID_COWORKER_COMPETENCEPROFILE = 47; // Url = /#/tm/coworker/competenceprofile
export const ID_COWORKER_DEVELOPMENTPLAN = 48; // Url = /#/tm/coworker/personalgoals/developmentplan
export const ID_MANAGER_OVERVIEW = 49; // Url = /#/tm/manager/dashboard
export const ID_MANAGER_ORGANISATIONGOALS = 50; // Url = /#/tm/manager/editorganisationalgoals
export const ID_MANAGER_COMPTALKS = 51; // Url = /#/tm/manager/editcomptalk
export const ID_MANAGER_SEARCHANDFILTER = 52; // Url = /#/tm/manager/talentfinder
export const ID_MANAGER_COMPETENCEMAINTENANCE = 53; // Url = /#/tm/manager/competencemaintenance
export const ID_ADMINISTRATION = 54; // Url = /talentmanagement/manager/administration.aspx
export const ID_COWORKER_CAREERPATHS = 55; // Url = /#/tm/coworker/careerpath
export const ID_COWORKER_EDUCATIONHISTORYANDCV = 56; // Url = /#/tm/coworker/completedcourses
export const ID_COWORKER_MYACTIVITIES = 57; // Url = /#/tm/coworker/courseapplications
export const ID_COWORKER_CERTIFICATES = 58; // Url = /#/tm/coworker/certificates
export const ID_COWORKER_DOCUMENTS = 59; // Url = /#/tm/coworker/documents
export const ID_MANAGER_ATTESTATIONS = 60; // Url = /#/tm/manager/attest
export const ID_MANAGER_COMPETENCEANALYSIS = 61; // Url = /#/tm/manager/competenceanalysis
export const ID_MANAGER_CERTIFICATES = 62; // Url = /#/tm/manager/certificateanalysis
export const ID_MANAGER_COURSESTATISTICS = 63; // Url = /#/tm/manager/coursestatistics
export const ID_MANAGER_PLANNEDCOURSES = 64; // Url = /#/tm/manager/plannedcourses
export const ID_MANAGER_MNUREPORTS = 65; // Url = /#/tm/manager/reports
export const ID_MANAGER_ACTINGMANAGER = 66; // Url = /#/tm/manager/permissions
export const ID_MANAGER_SUCCESSIONPLAN = 67; // Url = /#/tm/manager/successionplan
export const ID_COWORKER_MYCOURSES = 68; // Url = /#/tm/coworker/mycourses
export const ID_MANAGER_ENGAGEMENT = 69; // Url = /#/tm/manager/engagement
export const ID_MANAGER_CHECKLISTS = 70; // Url = /#/tm/manager/editchecklists
export const ID_COWORKER_AUTHORISATIONS = 71; // Url = /#/tm/coworker/authorisations
export const ID_MANAGER_AUTHORISATIONS = 73; // Url = /#/tm/manager/authorisationanalysis
export const ID_COWORKER_ENGAGEMENT = 74; // Url = /#/tm/coworker/engagement
export const ID_MANAGER_COURSEAPPLICATIONS = 75; // Url = /#/tm/manager/courseapplications
export const ID_MANAGER_FEEDBACK = 76; // Url = /#/tm/manager/feedback
export const ID_COWORKER_BADGES = 77; // Url = /#/tm/coworker/badges
export const ID_COWORKER_LEADERBOARD = 78; // Url = /#/tm/coworker/leaderboard
export const ID_COURSE_CATALOGUE = 1010; // Url = /activities/listactivities.aspx
